// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--uBjic","content":"styles-module--content--bvIrB","collapsed":"styles-module--collapsed--1OXPu"};